import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
const genres = ['Salsa', 'Merengue', 'Bachata', 'Reguetón', 'Bolero', 'Pop Latino', 'Cumbia', 'Baladas'];
export function Repertoire() {
  const {
    t
  } = useLanguage();
  const loop = [...genres, ...genres];
  return <section id="repertorio" className="py-24 md:py-32 bg-ink overflow-hidden" data-id="element-137">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-12" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-139">
          <p className="text-gold text-xs tracking-[0.3em] mb-4" data-id="element-140">
            {t('rep.eyebrow')}
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-cream leading-tight max-w-2xl" data-id="element-141">
            {t('rep.title.1')}{' '}
            <span className="italic gold-text" data-id="element-142">{t('rep.title.2')}</span>
          </h2>
        </motion.div>
      </div>

      <div className="relative" data-id="element-143">
        <div className="marquee gap-4 px-6" data-id="element-144">
          {loop.map((g, i) => <span key={i} className="shrink-0 px-8 py-3 rounded-full border border-gold/30 text-cream/90 font-display text-2xl md:text-3xl whitespace-nowrap" data-id="element-145">
              {g}
            </span>)}
        </div>
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ink to-transparent pointer-events-none" data-id="element-146" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ink to-transparent pointer-events-none" data-id="element-147" />
      </div>
    </section>;
}